import React from "react";
import { useWatchState } from "@/store";
import { Modal } from "antd";
import "./style.less";

const NAME = "iframe";

const App = () => {

    const [[{ title = "反馈详情", show, hide, width = 800, height = "600px", url }]] = useWatchState(["modal." + NAME])

    return (
        <Modal
            title={title}
            className="modal-iframe"
            visible={show}
            width={width}
            maskClosable={false}
            destroyOnClose
            onCancel={hide}
            footer={false}
        >
            <iframe width="100%" height={height} src={encodeURI(url)} frameborder="0"></iframe>
        </Modal>
    );
}

export default App;